var site = site || {};

(function ($) {
  site.direction = site.direction || {};

  Drupal.behaviors.discoverFoundationV2 = {
    attach: function (context) {
      var discoverCarousel = $('.js-discover-foundation-carousel', context);
      var discoverPC = $('.js-discover-foundation-pc', context);
      var $slickWrapper = $('.quickshop_container__content', discoverCarousel);
      var $qsContainer = $('.quickshop_container .js-quickshop-container');

      // QS close others on PC
      discoverPC.each(function () {
        var $qsButtonRow1 = $('.quickshop_container.row1 .js-quickshop-link');
        var $qsButtonRow2 = $('.quickshop_container.row2 .js-quickshop-link');
        var $qsButtonRow3 = $('.quickshop_container.row3 .js-quickshop-link');
        var $qsContainer1 = $('.quickshop_container.row1 .js-quickshop-container');
        var $qsContainer2 = $('.quickshop_container.row2 .js-quickshop-container');
        var $qsContainer3 = $('.quickshop_container.row3 .js-quickshop-container');

        $qsButtonRow1.click(function () {
          $qsContainer2.removeClass('active active--1 active--2 active--3').hide();
          $qsContainer3.removeClass('active active--1 active--2 active--3').hide();
        });
        $qsButtonRow2.click(function () {
          $qsContainer1.removeClass('active active--1 active--2 active--3').hide();
          $qsContainer3.removeClass('active active--1 active--2 active--3').hide();
        });
        $qsButtonRow3.click(function () {
          $qsContainer1.removeClass('active active--1 active--2 active--3').hide();
          $qsContainer2.removeClass('active active--1 active--2 active--3').hide();
        });
      });

      // Mobile carousel
      discoverCarousel.each(function () {
        var discoverItem = $('.js-discover-foundation-block-item', discoverCarousel);
        var carouselWidth = 767;
        var $slides = $('.js-discover-foundation-block', $slickWrapper);

        $(this).each(function () {
          var $module = $(this);
          var $nav = $('.discover-slide__nav', $module);

          if ($slides.length > 1) {
            $slickWrapper.slick({
              rtl: site.direction.isRTL,
              fade: true,
              autoplay: false,
              arrows: true,
              onBeforeChange: function () {
                $qsContainer.removeClass('active active--1 active--2 active--3').hide();
              }
            });

            $slickWrapper.prepend($('<div>', { class: 'discover-slide__nav' }));

            $('.discover-slide__nav').append(
              '<button type="button" class="slick-prev"></button> <button type="button" class="slick-next"></button>'
            );

            $slickWrapper.slick({
              prevArrow: $('.slick-prev', $module),
              nextArrow: $('.slick-next', $module)
            });
          }
        });
      });
    }
  };
})(jQuery);
